import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=2676eb2a&scoped=true"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=2676eb2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676eb2a",
  null
  
)

export default component.exports